/* Auto-konverterer h2-seksjoner i produktbeskrivelsen til collapsible bokser.
   Hopper over FAQ-overskriften (håndteres av faq-accordion.js). */
(function () {
  'use strict';

  function isFaqHeading(h2) {
    var t = h2.textContent.trim().toLowerCase();
    return t.indexOf('ofte stilte spørsmål') === 0;
  }

  function isFirstContentElement(h2) {
    // Hopp over hvis h2 er første innholdselement i sin parent — da er det
    // hovedoverskriften til beskrivelsen, ikke en sub-seksjon.
    var parent = h2.parentElement;
    if (!parent) return false;
    var first = parent.firstElementChild;
    while (first && (first.tagName === 'STYLE' || first.tagName === 'SCRIPT')) {
      first = first.nextElementSibling;
    }
    return first === h2;
  }

  function shouldEnhance(h2) {
    if (h2.dataset.sectionAccordion === 'done') return false;
    if (h2.classList.contains('faq-section-heading')) return false;
    if (isFaqHeading(h2)) return false;
    // Kun innenfor produktdetaljer (PDP)
    if (!h2.closest('.product-details')) return false;
    // Hovedoverskrift på beskrivelsen — ikke gjør collapsible
    if (isFirstContentElement(h2)) return false;
    return true;
  }

  function enhance(h2) {
    if (!shouldEnhance(h2)) return;
    h2.dataset.sectionAccordion = 'done';

    var content = [];
    var node = h2.nextElementSibling;
    while (node && node.tagName !== 'H2') {
      content.push(node);
      node = node.nextElementSibling;
    }
    if (content.length === 0) return;

    var item = document.createElement('div');
    item.className = 'product-section';

    // Bevar h2 som wrapper rundt knappen — viktig for SEO (heading-hierarki)
    // og tilgjengelighet (screen readers leser fortsatt seksjonen som heading).
    var heading = document.createElement('h2');
    heading.className = 'product-section__heading';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'product-section__button';
    btn.setAttribute('aria-expanded', 'false');

    var label = document.createElement('span');
    label.className = 'product-section__label';
    label.textContent = h2.textContent.trim();
    btn.appendChild(label);

    var icon = document.createElement('span');
    icon.className = 'product-section__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML =
      '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
    btn.appendChild(icon);

    heading.appendChild(btn);

    var panel = document.createElement('div');
    panel.className = 'product-section__panel';
    var inner = document.createElement('div');
    inner.className = 'product-section__inner';
    for (var i = 0; i < content.length; i++) {
      inner.appendChild(content[i]);
    }
    panel.appendChild(inner);

    item.appendChild(heading);
    item.appendChild(panel);

    btn.addEventListener('click', function () {
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    h2.parentNode.replaceChild(item, h2);
  }

  function run(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var headings = scope.querySelectorAll('h2');
    for (var i = 0; i < headings.length; i++) {
      enhance(headings[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run(document);
    });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    run(e.target);
  });
})();
